import { Button, Container, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, makeStyles, Paper, Radio, RadioGroup, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";

const courseId = {
  ECS1: "FCSReconocimientoPrecoz",
  ECS2: "FCSRCPPrecoz",
  ECS3: "FCSDesfibrilacionPrecoz",
};

export const EvaluationItem = ({ nextItem, data, current, max, nAttemps, firebase, evaluationID, answerFeedback }) => {
  //console.log("datos", data);
  const correct = parseInt(data.correct);
  const attempRef = firebase.evaluationAttemp(firebase.currentUser().uid, evaluationID, nAttemps);
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [isAnswerChecked, setisAnswerChecked] = useState(false);
  const [userAnswer, setUserAnswer] = useState(-1);
  const [error, setError] = useState(false);
  const [helperText, sethelperText] = useState("");

  const checkAnswer = () => {
    /** se comprueba si se ha seleccionado alguna respuesta */
    if (!isAnswerChecked) {
      let feedbacktext;
      let answerResult; // correct or wrong

      /** En caso de que se haya respondido hay que comprobar el estado de la respuesta */

      if (correct === userAnswer) {
        setError(false);
        feedbacktext = "";
        answerResult = "correct";
      } else {
        setError(true);
        feedbacktext = data.responses[correct];
        answerResult = "wrong";
      }
      //envia al componente padre el tipo y contenido del feedback
      answerFeedback(answerResult !== "correct", feedbacktext);
      setisAnswerChecked(true);
      sethelperText(feedbacktext);
      /**
       * Se guarda la opcion seleccionada por el usuario para despues hacerle el resumen
       */
      attempRef.child(`data/question${current}`).set({
        question: data.question,
        correctAnswer: data.responses[correct],
        userAnswer: data.responses[userAnswer],
      });

      /**
       * Se calcula y se almacena el numero de aciertos y fallos
       * despues, en el resultado final se recuperan estos datos para hacer el resumen
       */
      attempRef
        .child(`metadata/${answerResult}`)
        .once("value")
        .then((snap) => attempRef.child(`metadata`).update({ [answerResult]: snap.val() ? snap.val() + 1 : 1 }));
      /**
       * se actualiza el numero de pregunta para despues poder recuperar el test desde la misma pregunta,
       * en caso de ser la última pregunta, no se actualizará el contador para evitar errores
       */
      const dataToUpdate = {
        currentQuestion: current + (current !== max ? 1 : 0),
        isOnProgress: current !== max,
        isReviewed: false,
      };
      firebase.evaluationMetadata(firebase.currentUser().uid, evaluationID).update(dataToUpdate);
    } else {
      /** En caso de que se haya chekeaco, se habra procesado ya la respuesta del usuario,
       * se inicializa el estado del componente y se pasa al siguiente cuestionario
       */
      nextItem();
      setisAnswerChecked(false);
      setUserAnswer(-1);
      sethelperText("");
      setError(false);
    }
  };

  const handleRadioChange = (event) => {
    /** Solo se puede cambiar la respuesta si aun no se ha comprobado la respuesta */
    !isAnswerChecked && setUserAnswer(parseInt(event.target.value));
  };

  const labelRadioChange = (value) => {
    !isAnswerChecked && setUserAnswer(value);
  };

  return (
    <>
      <Grid item xs={12} container>
        <Paper variant="outlined" className={classes.formCard}>
          <Grid container item xs={12}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">
                {t("of", { current: current + 1, max: max + 1 })}
              </Typography>
              <Typography variant="subtitle1">{t(data.question)}</Typography>
              <Grid container spacing={0} style={{ marginTop: 16 }}>
                {data.responses.map((response, key) => (
                  <Grid container item direction="row">
                    <Grid item>
                      <Radio checked={userAnswer === key} disabled={isAnswerChecked} onChange={handleRadioChange} key={key} value={key} />
                    </Grid>
                    <Grid item xs={10}>
                      <Typography
                        variant="body1"
                        style={{ marginTop: 9, cursor: "pointer" }}
                        onClick={() => {
                          labelRadioChange(key);
                        }}
                      >
                        {t(response)}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
              <FormHelperText error={error}>
                <Typography variant="body1">
                  <br />
                  {helperText !== "" && t("testWrongAsnwer")}
                  <br />
                  <strong>{helperText !== "" && t(helperText)}</strong>
                </Typography>
              </FormHelperText>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={6} container justify="flex-start">
        <Button variant="outlined" style={{ textTransform: "none" }} onClick={() => history.push(ROUTES.MODULE.replace(":id", courseId[evaluationID]))} color="secondary">
          {t("volver_al_modulo")}
        </Button>
      </Grid>
      <Grid item xs={6} container justify="flex-end">
        <Button
          className={isAnswerChecked && "pulse"}
          variant={!isAnswerChecked ? "outlined" : "contained"}
          style={{ textTransform: "none", color: isAnswerChecked && "whitesmoke" }}
          onClick={() => checkAnswer()}
          color={!isAnswerChecked ? "secondary" : "primary"}
          disabled={userAnswer === -1}
        >
          {!isAnswerChecked ? t("check") : t("next")}
        </Button>
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  formCard: {
    width: "100%",
    borderRadius: 6,
    [theme.breakpoints.up("md")]: {
      padding: "24px 36px",
    },
    [theme.breakpoints.down("md")]: {
      padding: 16,
    },
  },
}));
